export class FlipCameraMobileController {
    /* @ngInject */
    constructor(flipCamera) {
        this.flipCamera = flipCamera;
    }
    switchCamera() {
        if (!this.isDisabled) {
            this.flipCamera();
        }
    }
}
